import React from 'react';
import { Link } from 'react-router-dom';
import { devicesApi } from '../../services/endpoints';
import { useApiData, StateBlock } from './useApiData';

export default function MyDevices() {
  const { data: devices, loading, error, reload } = useApiData(() => devicesApi.list());

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold">My Devices</h1>
        <Link to="/dashboard/devices/add" className="btn-primary !py-2 !px-4 text-sm">
          + Add Device
        </Link>
      </div>
      <StateBlock loading={loading} error={error} onRetry={reload} isEmpty={devices?.length === 0} emptyLabel="No devices yet — add your first device to get started.">
        <div className="grid md:grid-cols-3 gap-4">
          {devices?.map((d) => (
            <div key={d.id} className="glass rounded-xl p-4">
              <div className="flex items-center justify-between">
                <p className="font-medium">{d.name}</p>
                <span className={`text-xs px-2 py-0.5 rounded-full ${d.is_online ? 'bg-green-500/20 text-green-400' : 'bg-white/10 text-white/40'}`}>
                  {d.is_online ? 'Online' : 'Offline'}
                </span>
              </div>
              <p className="text-xs text-white/40 mt-1">
                {d.device_type}{d.room_name ? ` · ${d.room_name}` : ''}
              </p>
              {d.capabilities?.length > 0 && (
                <div className="flex flex-wrap gap-1 mt-2">
                  {d.capabilities.slice(0, 4).map((c) => (
                    <span key={c} className="text-[10px] bg-white/5 text-white/40 px-1.5 py-0.5 rounded">{c}</span>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </StateBlock>
    </div>
  );
}
